import { CloudToBridgeCommand } from './commands';

export interface IBaseBridgeCommand {
  type: CloudToBridgeCommand;
}

export interface IBridgeLogs {
  logs: string;
}
